import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, Card, CardMedia, CardContent, Button, IconButton, Container } from '@mui/material';
import categoryimage from '../../assets/home/category1.png'
import EastIcon from '@mui/icons-material/East';
import { useMediaQueries } from '../../usecontext/UseProvider';
import { getSomethingUnique } from '../../services/SomethingUnique';
import { useNavigate } from 'react-router-dom';

const UniqueSection = () => {
    const { isSmallScreen, isMediumScreen } = useMediaQueries();
    const [somethingUnique, setSomethingUnique] = useState([]);
    const navigate = useNavigate();

    const getSomethingUniqueData = async () => {
        try {
            const response = await getSomethingUnique();
            setSomethingUnique(response.categoryItemDataSomethingUnique);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getSomethingUniqueData();
    }, []);

    return (
        <Container sx={{ py: { lg: 5, xs: 3 }, textAlign: 'center' }}>
            <Typography data-aos="fade-up" variant={isSmallScreen ? 'h6' : isMediumScreen ? 'h5' : 'h4'} sx={{ fontWeight: 700 }} gutterBottom>
                Something Unique
            </Typography>
            <Typography data-aos="fade-up" variant="subtitle1" sx={{ mb: { lg: 6, xs: 3 } }}>
                Elevate Your Digital World with Zula
            </Typography>
            <Grid container spacing={isSmallScreen ? 0 : 3}>
                {somethingUnique?.map((item, index) => (
                    <Grid item xs={12} sm={6} lg={3} key={index}
                        data-aos="zoom-in" // AOS animation
                        data-aos-delay={index * 200} // Staggered animation
                    >
                        <Card
                            onClick={() => navigate(`product-detail/${item?._id}`)}
                            sx={{
                                borderRadius: '0',
                                display: 'flex',
                                cursor: 'pointer',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                position: 'relative',
                                overflow: 'visible',
                                boxShadow: 'none',
                                '&:hover .title': {
                                    color: '#01A0E2',
                                }
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={item?.images[0]?.url}
                                alt={item?.name}
                                sx={{ borderRadius: '50%', height: '260px', maxWidth: '300px' }}
                            />
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    width: '100%',
                                    height: '100%',
                                    transition: 'opacity 0.3s ease-in-out',
                                    backgroundColor: '#00000080',
                                    opacity: 0,
                                    borderRadius: '50%',
                                    maxHeight: '260px', maxWidth: '300px',
                                    '&:hover': {
                                        opacity: 1,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translate(-50%, -0%)',
                                        top: '45%', textAlign: 'center',
                                        color: '#0A2357',
                                        width: 'inherit',
                                    }}
                                >
                                    <IconButton
                                        sx={{
                                            p: 1.5, backgroundColor: '#01A0E2',
                                            color: '#fff',
                                            '&:hover':
                                                { backgroundColor: '#01A0E2' }
                                        }}
                                    >
                                        <EastIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                            <CardContent className="title">
                                {item?.name}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Button
                variant="varient"
                data-aos="fade-up" // AOS animation
                data-aos-delay="400"
                sx={{
                    borderColor: '#fff',
                    backgroundColor: '#01A0E2',
                    color: '#fff',
                    borderRadius: '0',
                    mt: { sm: 4, xs: 2 },
                    fontSize: { lg: '20px' }
                }}
                onClick={() => navigate("/contactus")}>
                Interior & Architect
            </Button>
        </Container >
    );
};

export default UniqueSection;